import React, { FC, useState, useEffect } from 'react';
import { Seo, PageLayout, BackDrop, Button } from '../../components';
import config from '../../../app-config.json';
import { siteMetadata } from '../../../gatsby-config';
import * as s from '../../style.pages/index.style';
import { BodyWrap } from "../taher-scheme";
import { getCookie } from '../../helper';
import * as formStyle from '../../components/Form/style';
import { useAppDispatch, useAppSelector } from '../../reduxStore/store';
import { CircularProgress, Grid, TextField, Typography } from '@material-ui/core';
import { ErrorDialog, LoginFailDialog, WarningDialog } from '../../components/Alert';
import { GraphQLResult } from '../../typedefs';
import { QardanloginResponse } from '../../graphql/types';
import { checkTokenExpiryQardanApplicant, loginToQardanPortal, verifyQardanSecuritycode } from '../../reduxStore/slices/qardanPortalSlice';
import QardanPortalLoginForm, { FormFields as LoginFormProps } from '../../components/Form/QardanPortalLoginForm';
import { PageProps, navigate } from 'gatsby'

const PARENT_PAGE_TITLE = config.pages.QARDAN_HASANA.title;
const PAGE_TITLE = config.pages.QARDAN_HASANA.routes.login.title;
const PARENT_PAGE_PATH = config.pages.QARDAN_HASANA.path;
const LOGIN_FORM_PATH = config.pages.QARDAN_HASANA.routes.login.path;
export const LOGIN_PAGE_LINK = `${PARENT_PAGE_PATH}${LOGIN_FORM_PATH}`;


const Login: FC<PageProps> = ({ }) => {
    return (
        <PageLayout>
            <Seo title={`${PAGE_TITLE} | ${PARENT_PAGE_TITLE} | ${siteMetadata.title}`} />
            <BodyWrap >
                <br />
                <Typography variant='h2' >{PARENT_PAGE_TITLE}</Typography>
                <Typography variant='h6' color='inherit' gutterBottom >(Account Login)</Typography>
                <hr /><br /> <br />
                <LoginFormHandler />
                {/* <br /> */}
                {/* <Typography style={{ minWidth: '280px', maxWidth: '500px', margin: '0 auto' }} >Don't have an account? <Link to={NEW_ACCOUNT_FORM_LINK} >Click here</Link></Typography> */}
                <br />
            </BodyWrap>
        </PageLayout>
    )
};

export default Login;


const LoginFormHandler: FC<{}> = ({ }) => {
    const dispatch = useAppDispatch();
    const fetchingStatus = useAppSelector(s => s.qardanPortal.fetchingStatus);
    const [loginDone, setLoginDone] = useState(false);
    const [applicantId, setApplicantId] = useState("");

    /* Login callback */
    const onLogin = async (val: LoginFormProps) => {
        setApplicantId(val.applicantId);
        const { res } = await new Promise<{ err?: GraphQLResult<any>, res?: QardanloginResponse }>((resolve, reject) => {
            dispatch(loginToQardanPortal({
                userId: val.applicantId, password: val.password,
                callback: (err, res) => {
                    if (res) {
                        res.accessToken && navigate(PARENT_PAGE_PATH);
                        resolve({ res });
                        return
                    };
                    err && resolve({ err });
                    err?.errors && LoginFailDialog(err.errors[0].message)
                }
            }));
        });
        res?.userDetails && setLoginDone(true);
    }

    useEffect(() => {
        (async () => {
            // console.log(getCookie("hs_auth_token"))
            if (getCookie("qardan_auth_token")) {
                const { err, res } = await new Promise<{ err: any, res: any }>((resolve, reject) => {
                    dispatch(checkTokenExpiryQardanApplicant({
                        callback: (err, res) => {
                            resolve({ err, res })
                        }
                    }))
                })
                if (res) { navigate(PARENT_PAGE_PATH) }
            }
        })()
    }, [])

    return (
        <>
            <BackDrop open={fetchingStatus.checkTokenExpiryQardanApplicant} >
                <Typography style={{ color: 'white' }} variant='h2' >Loading....</Typography>
            </BackDrop>

            {!loginDone ?
                <QardanPortalLoginForm handleSubmit={onLogin} /> :
                <VerifyCode applicantId={applicantId} />
            }
            {/* <LoginForm idName={hsNumberFieldName} idTitle='Enter HS/TM Number'
                handleSubmit={onLogin}
            /> */}
        </>
    )
}


const VerifyCode: FC<{ applicantId: string }> = ({ applicantId }) => {
    const dispatch = useAppDispatch();
    const isVerifyingCode = useAppSelector(s => s.hsPortal.fetchingStatus.verifyHSsecuritycode);
    const [code, setCode] = useState("");

    /* verificationCode callback */
    const onCodeVerify = async () => {
        await new Promise<GraphQLResult<any> | QardanloginResponse>((resolve, reject) => {
            dispatch(verifyQardanSecuritycode({
                applicantId, verificationCode: code,
                callback: (err, res) => {
                    if (res) { navigate(PARENT_PAGE_PATH); resolve(res) };
                    err?.errors && ErrorDialog("Verification Failed", err.errors[0].message)
                    err && resolve(err);
                }
            }));
        })
    }

    return (
        <Grid style={{ ...formStyle.formStyle(), minWidth: '280px', maxWidth: '500px', margin: '0 auto' }} >
            <BackDrop open={isVerifyingCode} >
                <Typography style={{ color: 'white' }} variant='h2' >Loading....</Typography>
            </BackDrop>

            <Typography>
                <span style={{ fontSize: "22px", fontWeight: "bold" }} >Enter your verification code</span>
                <br /><br />
                A Verification Code has been sent to your email address.
            </Typography>

            <br />

            <Grid container item spacing={1} xs={12} direction='column' justify='center' >
                <Grid item container alignItems='center' >
                    <TextField required fullWidth label="Code" type='text' variant='outlined' value={code} onChange={e => setCode(e.target.value)} />
                </Grid>
                <br />
                <Grid item container direction='column' >
                    <Button onClick={onCodeVerify} disabled={(!code || isVerifyingCode)} color='primary' size='large' type='submit' >
                        {isVerifyingCode ? <div><CircularProgress color='inherit' /></div> : <div>Verify</div>}
                    </Button>
                </Grid>
            </Grid>
            <br />
        </Grid>
    )
}

